
import { Component, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { RoomSpace } from '@/utils/models';

@Component({ components: { Popup } })
export default class AddRoomFromHistoryPopup extends Vue {
  @Prop() private roomSpace!: RoomSpace;
  @Prop() private addSelectedRoomSpaceFromHistory!: (roomSpace: RoomSpace) => void;
  @Prop() private isVisible!: boolean;

  private onConfirm(): void {
    this.addSelectedRoomSpaceFromHistory(this.roomSpace);
  }

  private hidePopup(): void {
    this.$emit('close');
  }
}
